import { ValidateNumber } from "@/util/ValidationUtil.ts";

export class InspectionOtherCpoDto {
    id?: bigint;
    /**
     * CPO 명
     */
    cpoName: string;
    /**
     * 충전기 제조사
     */
    maker: string;
    /**
     * 보유 거점수
     */
    @ValidateNumber("보유 거점", false)
    locationRemarks: string;
    /**
     * 층수 ( 층 )
     */
    @ValidateNumber("", false)
    floor: number;
    /**
     * 기둥 ( 기둥 )
     */
    @ValidateNumber("", false)
    pillar: string;
    /**
     * 용량
     */
    @ValidateNumber("", false)
    capacity: number;
    /**
     * 갯수 ( 기 )
     */
    @ValidateNumber("", false)
    count: number;
    /**
     * 거점 위치
     */
    cpoLocation: string;

    constructor(data?: InspectionOtherCpoDto) {
        if (data) {
            Object.assign(this, data);
        } else {
            this.cpoName = "";
            this.maker = "";
            this.locationRemarks = "";
            this.floor = 0;
            this.pillar = "";
            this.capacity = 0;
            this.count = 0;
            this.cpoLocation = "";
        }
    }
}
